export default __webpack_public_path__ + "assets/ico_booking_others-7e84e907.svg";